import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const canRefreshProduct = map.useCanRefreshProduct()

    if (! canRefreshProduct) {
        return null
    }

    return {
        key: 'refresh-product',
        label: '重载制品',
        onClick: () => map.cmdRefreshProduct(),
    }
}
